import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import Sidebar from "@/components/Sidebar";
import { BrandLogo } from "@/components/BrandLogo";
import TrialBanner from "@/components/TrialBanner";
import { recordSignal } from "@/lib/api";

const MODULES = ["dashboard", "businesses", "inbox", "automations", "crm", "quotes", "jobs",
  "invoices", "legal", "team", "billing", "files", "memory", "search", "settings", "profile"];

export default function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const seg = loc.pathname.replace(/^\/app\/?/, "").split("/")[0];
    if (seg && MODULES.includes(seg)) recordSignal("visit", seg);
  }, [loc.pathname]);

  return (
    <div className="flex h-screen w-full overflow-hidden bg-black text-white">
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center justify-between border-b border-white/8 px-4 py-3 lg:hidden">
          <button onClick={() => setMobileOpen(true)} data-testid="mobile-menu-btn" className="text-white/70">
            <Menu className="h-6 w-6" />
          </button>
          <BrandLogo size={26} textClass="text-base" />
          <span className="w-6" />
        </header>
        <main className="min-h-0 flex-1 overflow-hidden">
          <div className="flex h-full flex-col">
            <TrialBanner />
            <div className="min-h-0 flex-1 overflow-hidden">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
